<forge-card class="chart" no-padding>
    <forge-toolbar>
        <div slot="start" fxLayout="column">
            <h2 class="forge-typography--heading4">{{ChartTitle}}</h2>
            @if (isLoaded) {
            <truncate-text fxFlex="100" [allowHtml]="true" [mainText]="ChartSubtitle"
                class="forge-typography--subheading1">
            </truncate-text>
            }
        </div>

        <div slot="end" class="total">
            <span class="forge-typography--heading2">Ordered total:</span> {{total}}
        </div>
    </forge-toolbar>

    <div class="metadata-padding">
        @if (isLoaded) {
        <div fxLayout="row">
            @if (showChart()) {
            <chartjs-container [config]="chartConfig">
            </chartjs-container>
            }
            @if (!chartHasData) {
            <div>
                Not enough data to display graph
            </div>
            }
        </div>
        }

        @else {
        <busy-indicator [chart]="true"></busy-indicator>
        }
    </div>
</forge-card>